import * as React from "react";
import { useHistory } from "react-router-dom";
import { useSeo } from "../../hooks";

import DiscordIcon from "../../assets/discord-icon.svg";

const ContactPage: React.FunctionComponent = () => {
    const history = useHistory();

    useSeo({
        title: "Contact Oberin - Support, Discord and Community Help",
        description:
            "Get help with Oberin through the official Discord, forums, and in-game support channels.",
        canonical: "https://www.oberin.be/contact",
        robots: "index,follow",
        twitterCard: "summary",
    });

    const handleGoToForumsCLicked = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
        event.preventDefault();
        history.push("/forum");
    };

    /***************************************************
     * Render
     ***************************************************/
    return (
        <div className="w-100 px-2">
            <div className="box-shadow">
                <div className="title-bar px-2">
                    <h1 className="mb-0 title-bar-heading">Contact us!</h1>
                </div>
                <div className="d-flex flex-column bg-white p-2">
                    {/* Support */}
                    <div className="title-bar dark px-2">
                        <span>Support</span>
                    </div>
                    <span>
                        For support, either check the{" "}
                        <a
                            href="/forum"
                            className="text-dark-red"
                            onClick={handleGoToForumsCLicked}
                        >
                            Forums
                        </a>
                        , use '/help' in-game, or contact us through our
                        Discord!
                        <br />
                        You can find the link to discord in the sidebar menus.
                    </span>

                    {/* Bugs and exploits */}
                    <div className="mt-2 title-bar dark px-2">
                        <span>Bugs, exploits and other oddities</span>
                    </div>
                    <span>
                        To report a bug, exploit, or anything else, much like
                        above, please contact us through the{" "}
                        <a
                            href="/forum"
                            className="text-dark-red"
                            onClick={handleGoToForumsCLicked}
                        >
                            Forums
                        </a>
                        , through '/help' in-game, or contact us through our
                        Discord.
                    </span>

                    {/* Others */}
                    <div className="mt-2 title-bar dark px-2">
                        <span>Anything else</span>
                    </div>
                    <span>
                        For any other issues, please contact either Bobley or
                        Faelan through the Discord.
                    </span>

                    <a
                        className="mt-2 d-flex align-items-center"
                        href="https://discord.gg/oberin"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className="discord-image img-fluid"
                            alt="Join Oberin on Discord"
                            src={DiscordIcon}
                        />
                        <span className="ml-2">Discord Invite</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;
